// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".barcode-check{\n    position: relative;\n    left: 25px;\n}", "",{"version":3,"sources":["webpack://./src/app/components/products/products.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;AACd","sourcesContent":[".barcode-check{\n    position: relative;\n    left: 25px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
